import React from 'react';
import clsx from 'clsx';
import MuiCardActions from '@material-ui/core/CardActions';
import { CARD_ACTIONS } from 'ctsutheme/core';

const CardActions = ({ className, contained, ...props }) => (
  <MuiCardActions
    className={clsx(CARD_ACTIONS.root, className, contained && CARD_ACTIONS.contained)}
    {...props}
  />
);

export default CardActions;
